/* LOOP theme — minimal, dependency-free */
(function () {
  'use strict';

  /* ---- sticky header ---- */
  var hdr = document.querySelector('.hdr');
  if (hdr) {
    var onScroll = function () {
      hdr.classList.toggle('is-stuck', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- mobile drawer ---- */
  var drawer = document.getElementById('NavDrawer');
  document.querySelectorAll('[data-drawer-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (drawer) { drawer.classList.add('open'); document.body.style.overflow = 'hidden'; }
    });
  });
  document.querySelectorAll('[data-drawer-close]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (drawer) { drawer.classList.remove('open'); document.body.style.overflow = ''; }
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('open')) {
      drawer.classList.remove('open'); document.body.style.overflow = '';
    }
  });

  /* ---- scroll reveal ---- */
  var rv = document.querySelectorAll('.rv');
  if (rv.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    rv.forEach(function (el) { io.observe(el); });
  } else {
    rv.forEach(function (el) { el.classList.add('in'); });
  }

  /* ---- money ---- */
  function money(cents) {
    var fmt = (window.LOOP && window.LOOP.moneyFormat) || '£{{amount}}';
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withDec = parts.join('.');
    var noDec = parts[0];
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withDec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDec.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDec);
  }

  /* ---- variant picker ---- */
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var btn = root.querySelector('[data-add]');
    var btnText = root.querySelector('[data-add-text]');

    function selected() {
      var out = [];
      root.querySelectorAll('[data-option-index]').forEach(function (group) {
        var i = parseInt(group.getAttribute('data-option-index'), 10);
        var checked = group.querySelector('input:checked');
        if (checked) out[i] = checked.value;
      });
      return out;
    }

    function match(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] !== undefined && v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function update() {
      var v = match(selected());
      root.querySelectorAll('[data-option-value-label]').forEach(function (lbl) {
        var group = lbl.closest('[data-option-wrap]');
        if (!group) return;
        var c = group.querySelector('input:checked');
        lbl.textContent = c ? c.value : '';
      });

      if (!v) {
        if (btn) btn.disabled = true;
        if (btnText) btnText.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price);
          compareEl.hidden = false;
        } else { compareEl.hidden = true; }
      }
      if (btn) btn.disabled = !v.available;
      if (btnText) btnText.textContent = v.available ? 'Add to bag — ' + money(v.price) : 'Sold out';

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    root.querySelectorAll('[data-option-index] input').forEach(function (i) {
      i.addEventListener('change', update);
    });
    update();
  });

  /* ---- gallery thumbs ---- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main] img');
    g.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (!main) return;
        var src = t.getAttribute('data-src');
        var srcset = t.getAttribute('data-srcset');
        if (src) main.src = src;
        if (srcset) main.srcset = srcset;
        g.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
      });
    });
  });

  /* ---- quantity steppers ---- */
  document.querySelectorAll('.qty').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!input) return;
        var step = b.getAttribute('data-step') === 'up' ? 1 : -1;
        var min = parseInt(input.getAttribute('min') || '0', 10);
        var val = parseInt(input.value || '1', 10) + step;
        input.value = val < min ? min : val;
        if (q.hasAttribute('data-autosubmit')) {
          var form = q.closest('form');
          if (form) form.submit();
        }
      });
    });
  });
})();


/* ---- variant image switching -------------------------------------------
   Swaps the main product photo when a variant (e.g. colour) is selected.
   Reads Shopify's own /products/{handle}.js so no Liquid changes are needed.
   Falls back silently if a variant has no image of its own. ---------------- */
(function () {
  'use strict';
  var root = document.querySelector('[data-product-form]');
  if (!root) return;

  var mainImg = root.querySelector('[data-gallery-main] img');
  if (!mainImg) return;

  var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
  if (!m) return;

  var variants = null;

  function chosen() {
    var out = [];
    root.querySelectorAll('[data-option-index]').forEach(function (g) {
      var i = parseInt(g.getAttribute('data-option-index'), 10);
      var c = g.querySelector('input:checked');
      if (c) out[i] = c.value;
    });
    return out;
  }

  function paint() {
    if (!variants) return;
    var want = chosen();
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < want.length; j++) {
        if (want[j] !== undefined && v.options[j] !== want[j]) { ok = false; break; }
      }
      if (!ok) continue;
      var src = v.featured_image && v.featured_image.src;
      if (src && mainImg.getAttribute('src') !== src) {
        mainImg.removeAttribute('srcset');
        mainImg.setAttribute('src', src);
        if (v.featured_image.alt) mainImg.setAttribute('alt', v.featured_image.alt);
      }
      return;
    }
  }

  fetch('/products/' + m[1] + '.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (p) {
      if (!p || !p.variants) return;
      variants = p.variants;
      root.querySelectorAll('[data-option-index] input').forEach(function (inp) {
        inp.addEventListener('change', paint);
      });
      paint();
    })
    .catch(function () { /* no-op */ });
})();
